//Components
import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import store from "../src/redux/store";

//Components
import App from "./App/App";

//Utils
import { APPLICATION_CONFIGURATIONS } from "./Utils/ApplicationConfigurations";

//Strings
import i18n from "./Translations/i18n";

//Styles
import "./index.scss";

const language = APPLICATION_CONFIGURATIONS.applicationLanguage;

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n} locale={language}>
      <App />
    </I18nextProvider>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();
